import React, { useState } from "react"
import { useSelector } from "react-redux"
import { Box, IconButton, Typography } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"

import { getOrganizationsEnterpriseSelector } from "../../../reducers/Organizations/organizations"
import EditGeneralInfoModal from "./EditGeneralInfoModal"

const sx = {
  card: {
    bgcolor: "#FFFFFF",
    borderRadius: "4px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.06), 0 1px 1px rgba(0,0,0,0.04)",
    p: 3,
  },
  cardHead: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 2,
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 500,
    color: "#262626",
  },
  editBtn: {
    width: 36,
    height: 36,
    color: "primary.main",
    borderRadius: "50%",
    "& .MuiSvgIcon-root": { fontSize: 20 },
    "&:hover": {
      bgcolor: "#E3F2FD",
    },
  },
  fieldList: {
    display: "flex",
    flexDirection: "column",
  },
  fieldRow: {
    display: "grid",
    gridTemplateColumns: "200px 1fr",
    gap: "24px",
    py: "8px",
    alignItems: "baseline",
  },
  fieldLabel: {
    fontSize: 16,
    fontWeight: 400,
    color: "#7C7C7C",
  },
  fieldValue: {
    fontSize: 16,
    fontWeight: 400,
    color: "#262626",
  },
  fieldValueEmpty: {
    fontSize: 16,
    fontWeight: 400,
    color: "#7C7C7C",
  },
}

const booleanFieldLabel = (value) => (value == null ? null : value ? "Oui" : "Non")


const FieldRow = ({ label, value }) => (
  <Box sx={sx.fieldRow}>
    <Typography sx={sx.fieldLabel}>{label}</Typography>
    {value != null && String(value).trim().length > 0 ? (
      <Typography sx={sx.fieldValue}>{value}</Typography>
    ) : (
      <Typography sx={sx.fieldValueEmpty}>—</Typography>
    )}
  </Box>
)

const GeneralInfoSection = () => {
  const enterprise = useSelector(getOrganizationsEnterpriseSelector)
  const [editOpen, setEditOpen] = useState(false)

  if (!enterprise) return null

  return (
    <Box sx={sx.card}>
      <Box sx={sx.cardHead}>
        <Typography sx={sx.cardTitle}>Informations générales</Typography>
        <IconButton
          size="small"
          sx={sx.editBtn}
          onClick={() => setEditOpen(true)}
          aria-label="Modifier les informations générales"
        >
          <EditIcon />
        </IconButton>
      </Box>

      <Box sx={sx.fieldList}>
        <FieldRow label="Nom" value={enterprise.name} />
        <FieldRow label="Code" value={enterprise.code} />
        <FieldRow label="Envoi en province" value={booleanFieldLabel(enterprise.nationalSendField)} />
        <FieldRow label="Envoi à Paris" value={booleanFieldLabel(enterprise.sendCapitalField)} />
        <FieldRow label="Commerce de détail" value={booleanFieldLabel(enterprise.smallRetailField)} />
        <FieldRow label="Plateaux repas" value={booleanFieldLabel(enterprise.lunchbagField)} />
        <FieldRow label="Validation client requise" value={enterprise.requiresValidation ? "Oui" : "Non"} />
      </Box>

      <EditGeneralInfoModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        enterprise={enterprise}
      />
    </Box>
  )
}

export default GeneralInfoSection
